import { Link } from 'react-router-dom';
import styled, { FlattenSimpleInterpolation, css } from 'styled-components';
import Button from '@minecraft.button';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';
import TalentCard from '../../../common/TalentCard';
import { TalentCount } from '../../shared/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props): string => props.theme.colors.accent.ltGrey2};
  border-right: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
`;

export const SideBarItem = styled.div`
  padding: 1rem;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  }

  a {
    font-size: 1rem;
    display: flex;
    align-items: center;
    padding: 0.25rem 0;

    ${media.sm`
      font-size: 0.875rem;
    `}
  }

  ${media.sm`
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  `}
`;

export const FolderInfo = styled(SideBarItem)`
  background-color: ${(props): string => props.theme.colors.primary.white};

  ${media.sm`
    background-color: inherit;
  `}
`;

export const SelectWrapper = styled.div`
  width: 100%;
`;

export const StyledChevronLeftIcon = styled(Icon)`
  width: 1.0625rem;
  height: 1.0625rem;
  margin-right: 0.5rem;
`;

export const StyledGridViewIcon = styled(Icon)`
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 0.5rem;

  ${media.sm`
    height: 1rem;
    width: 1rem;
  `}
`;

export const FolderTalentCount = styled(TalentCount)`
  display: none;

  ${media.sm`
    display: flex;
  `}
`;

export const TalentList = styled.div`
  display: none;

  ${media.sm`
    display: flex;
    flex-direction: column;
    margin: 0.625rem -1.875rem 0;
  `}
`;

export const StyledChooseTalentButton = styled(Button)`
  padding: 0 1rem;
  width: 100%;
  margin-top: 1rem;
  font-size: 1rem;
  height: 2.5rem;

  ${media.sm`
    display: none;
  `}
`;

export const StyledDirectionButton = styled(Button)`
  min-width: auto;

  &,
  &:hover,
  &:active,
  &:focus {
    padding: 0;
    color: ${(props): string => props.theme.colors.primary.primary};
    text-decoration: none;
  }

  &:disabled {
    text-decoration: none;
  }
`;

export const StyledDirectionButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  margin-top: 0.625rem;

  ${media.sm`
    display: none;
  `}
`;

export const StyledTalentCardLink = styled(Link)`
  &,
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: initial;
    text-decoration: none;
  }
`;

export const StyledTalentCard = styled(TalentCard)<{ $isActive: boolean }>`
  margin: 0;
  position: relative;

  ${(props): FlattenSimpleInterpolation =>
    props.$isActive &&
    css`
      background-color: ${props.theme.colors.primary.white};
      box-shadow: inset -2px 0px 0px 0px ${props.theme.colors.primary.primary};
    `}

  & > div {
    background-color: transparent;
    border: 0;
    border-radius: 0;
  }
`;

export const LoaderWrapper = styled.div`
  position: relative;
  min-height: 10rem;
`;
